// extracted by css-extract-rspack-plugin
export default {"root":"TopBar_root__iTH3j","left":"TopBar_left__obL8s","goBackButton":"TopBar_goBackButton__Xbj50"};